export default __webpack_public_path__ + "static/media/project_banner_cathulhu.de9a0351.png";